import { Grid } from "@mui/material";
import React from "react";

export default function CustomHeader({ children }) {
  return (
    <Grid item xs={12}>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ borderBottom: "1px solid var(--qv-bd-e8e8e8, #E8E8E8)" }}
      >
        <Grid item xs={12}>
          <Grid sx={{px:{xs:1,sm:2.5}}} className="q-category-bottom-header">
            <span>{children}</span>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
